import { getInvoiceFileURL, getInvoices } from '@/api/settings-api'
import { GetInvoiceFileURLFileEnum } from '@itsrever/rever-api'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useEcommerceId } from './use-ecommerce-id'

export function useInvoices() {
  const ecommerceId = useEcommerceId()

  const invoicesQuery = useQuery({
    queryKey: ['invoices', ecommerceId],
    queryFn: () => getInvoices(ecommerceId ?? ''),
    enabled: !!ecommerceId,
    staleTime: 1000 * 60 * 10
  })

  return {
    invoices: invoicesQuery.data?.invoices ?? [],
    // Without an ecommerce the query never runs, and a pending query would spin forever.
    loadingInvoices: invoicesQuery.isPending && !!ecommerceId,
    invoicesError: invoicesQuery.isError,
    reloadInvoices: () => invoicesQuery.refetch()
  }
}

export function useInvoiceFile() {
  const ecommerceId = useEcommerceId()

  // The link is signed and short-lived, so it is asked for when the merchant clicks rather than
  // rendered into the table.
  const fileMutation = useMutation({
    mutationFn: ({
      invoiceId,
      file
    }: {
      invoiceId: string
      file: GetInvoiceFileURLFileEnum
    }) => getInvoiceFileURL(ecommerceId ?? '', invoiceId, file)
  })

  return { requestFile: fileMutation.mutateAsync }
}
